/* eslint-disable simple-import-sort/imports */
import { Admin, Resource } from 'react-admin';

import auth from './auth';
import { Dashboard } from './dashboard/Dashboard';
import i18nProvider from './localization';
import Manifest from './manifest';
import MyLayout from './appBar/MyLayout';
import myDataProvider from './MyDataProvider';
import { ProfileEdit } from './profile/ProfileEdit';
import { ShipmentsEditModal } from './shipments/ShipmentsEditModal';
import theme from './theme';
import User from './users';
import VuceDispatchCreate from './vuceDispatch/vuceDispatchCreate';
import BankDispatchCreate from './bankDispatch/bankDispatchCreate';

const App = () => (
  <Admin
    layout={MyLayout}
    theme={theme}
    authProvider={auth}
    dataProvider={myDataProvider}
    i18nProvider={i18nProvider}
    dashboard={Dashboard}
  >
    <Resource name="user" {...User} />
    <Resource name="manifest" {...Manifest} />
    <Resource name="profile" edit={ProfileEdit} />
    <Resource name="shipments" edit={ShipmentsEditModal} />
    <Resource name="vuceDispatch" create={VuceDispatchCreate} />
    <Resource name="bankDispatch" create={BankDispatchCreate} />
  </Admin>
);
export default App;
